import type { PblCaseStatus } from '@/types/pbl';

import type { PblCaseListFilter, PblDashboardCaseFilter } from './types';

export const PBL_DASHBOARD_FILTER_PARAM = 'dashboardFilter';

const dashboardCaseFilters = new Set<PblDashboardCaseFilter>([
  'pending_oc_review',
  'pending_timeslot_selection',
  'matching_attention',
  'pending_timeslot',
  'pending_appointment_confirmation',
]);

const dashboardCaseStatuses: Record<PblDashboardCaseFilter, PblCaseStatus[]> = {
  pending_oc_review: ['pending_oc_review'],
  pending_timeslot_selection: ['pending_appointment_confirmation'],
  matching_attention: [
    'manual_assignment_required',
    'pending_reassignment',
    'lawyer_declined',
    'lawyer_timeout',
  ],
  pending_timeslot: ['pending_lawyer_timeslot'],
  pending_appointment_confirmation: ['pending_appointment_confirmation'],
};

export const isPblDashboardCaseFilter = (value?: string | null): value is PblDashboardCaseFilter =>
  Boolean(value && dashboardCaseFilters.has(value as PblDashboardCaseFilter));

export const getPblDashboardCaseFilter = (searchParams: URLSearchParams) => {
  const value = searchParams.get(PBL_DASHBOARD_FILTER_PARAM);
  return isPblDashboardCaseFilter(value) ? value : null;
};

export const getPblDashboardCaseStatuses = (filter?: PblDashboardCaseFilter | null) =>
  filter ? dashboardCaseStatuses[filter] : null;

export const matchesPblDashboardCaseFilter = (
  backendStatus: string | null | undefined,
  filter: PblDashboardCaseFilter
) => dashboardCaseStatuses[filter].includes(backendStatus as PblCaseStatus);

export const addPblDashboardFilterOption = (
  filters: Array<{ value: PblCaseListFilter; label: string }>,
  filter: PblDashboardCaseFilter | null,
  label: string
) => {
  if (!filter || filters.some((item) => item.value === filter)) return filters;

  const [allFilter, ...remainingFilters] = filters;
  return [allFilter, { value: filter, label }, ...remainingFilters];
};
